<template>
  <div style="height:100%;">
  </div>
</template>
<script>
  export default {
    components: {},
    data() {
      return {};
    },
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/InnerWarning.vue